import { Box, Grid, Typography } from '@mui/material';

export default function Customize(props) {
    var gridMargin = props.gridMargin
    return (
        <Grid container spacing={4} sx={{ marginTop: "12px" }}>
            <Grid item xs={12} sm={12} md={4}>
                <Box sx={{ textAlign: 'left', paddingRight: "48px" }}>
                    <Box
                        component="img"
                        sx={{
                            display: 'flex',
                            height: "60px"
                        }}
                        alt="Illustration of small geography being pulled into a larger geography."
                        src="https://sde-resources.s3.amazonaws.com/img/custom.svg"
                    />
                    <Typography variant="h3">Analyze boundary scenarios</Typography>
                    <Typography variant="subtitle2" color="#adaca8" sx={{ marginTop: ".75rem" }}>
                        Upload your data, specify how enrollment is calculated, and set custom evaluation metrics.
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
                <Box sx={{
                    backgroundColor: '#efefef',
                    width: "100%",
                    height: "300px",
                    borderRadius: "24px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center"
                }}
                >
                    <Typography variant="body1" color="#adaca8" sx={{ margin: "128px" }}>
                    Assess trade-offs between key decisions to land on the boundary scenario that best suits your students.
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    )
}